import { AppRoutes } from "./routes";
import { AppProvider } from "./providers/app";
import { ColleagueDetailsProvider } from "contexts/ColleagueDetailsContext";

function App() {
  return (
    <AppProvider>
      <ColleagueDetailsProvider>
        <AppRoutes />
      </ColleagueDetailsProvider>
    </AppProvider>
  );
}

export default App;
